import { Box, IconButton, ListItem, ListItemButton } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LIGHT_GREY } from "styles/oneOffColor";

import { isPage } from "utils/general";
import { trackEvent } from "utils/tracking";
import { useCollection } from "utils/useCollection";

import { PageMenu } from "../../schema";
import styles from "../styles";
import Submenu from "./Submenu";

interface Props {
  page: string;
  handleClose: () => void;
  hasSubmenu?: boolean;
  onSubmenuClick?: () => void;
  subMenuText?: string;
  subMenuIcon?: string;
}

const LeftDrawerListItem = ({
  page,
  handleClose,
  hasSubmenu,
  onSubmenuClick,
  subMenuText,
  subMenuIcon,
}: Props) => {
  const { getTotal } = useCollection();
  const total = getTotal();
  const navigate = useNavigate();

  const navigateRoute = (page: string) => {
    trackEvent("Page Navigated", { route: `/${PageMenu[page].routes}` });
    navigate(`/${PageMenu[page].routes}`);
    handleClose();
  };

  const [openSubmenu, setOpenSubmenu] = useState<boolean>(false);
  const isActive = isPage(PageMenu[page].routes);

  return (
    <>
      <ListItem
        key={PageMenu[page].label}
        disablePadding
        sx={[isActive ? { backgroundColor: LIGHT_GREY } : {}]}
      >
        <ListItemButton onClick={() => navigateRoute(page)}>
          <Box component={"i"} className={PageMenu[page].icon} sx={{ mr: 1 }} />{" "}
          {PageMenu[page].label}
          {PageMenu[page].label === "Brands" && total > 0 && (
            <Box sx={styles.savedBrandIcon}>{total} saved</Box>
          )}
          {hasSubmenu && (
            <IconButton
              sx={{ fontSize: 12 }}
              onClick={(e) => {
                e.stopPropagation();
                setOpenSubmenu((prev) => !prev);
                trackEvent("Submenu Toggle");
              }}
            >
              <Box
                component="i"
                className={`fa-regular fa-chevron-${openSubmenu ? "up" : "down"}`}
              />
            </IconButton>
          )}
        </ListItemButton>
      </ListItem>

      {onSubmenuClick && subMenuText && subMenuIcon && (
        <Submenu
          onClick={onSubmenuClick}
          openSubmenu={openSubmenu}
          text={subMenuText}
          icon={subMenuIcon}
        />
      )}
    </>
  );
};

export default LeftDrawerListItem;
